import { CellContext } from '@tanstack/react-table';
import DateTimeText from 'src/components/DateTimeText/DateTimeText';
import { withFEUrl } from 'src/helpers/bridgeForFE';
import { FlashDiscountProductListItem, IAcceptedFlashProductListItem } from '../services/models/flash-discount';

interface IProps {
  cellContext: CellContext<FlashDiscountProductListItem | IAcceptedFlashProductListItem, unknown>;
}

export default function FlashProductsProductInfoCell(props: IProps) {
  const { cellContext: ctx } = props;

  const item = ctx?.row?.original;

  return (
    <div className="d-flex align-items-center gap-4">
      <div className="symbol symbol-75px me-5">
        <img src={item?.imageSrc} className="img-fluid" style={{ objectFit: 'contain' }} alt="" />
      </div>

      <div className="d-flex flex-column gap-4">
        <div
          className="d-flex gap-2 w-fit fw-bold"
          style={{
            backgroundColor: '#F5F5F5',
            padding: '3px 6px',
            borderRadius: '4px',
            color: '#666666',
            fontSize: '12px',
          }}
        >
          <DateTimeText value={item?.periodInfo?.[0]?.suggestDate} formatStr="D MMMM" tooltip={false} />
        </div>

        <div className="d-flex align-items-start">
          <div className="d-flex flex-column">
            <a href={withFEUrl(item?.slug)} target="_blank" rel="noreferrer">
              <span className="fw-bold fs-6 text-decoration-underline">{item.title}</span>
            </a>
            <div className="mt-3">
              <span>Barkod: </span>
              <span>
                <b>{item?.barcode}</b>
              </span>
            </div>
            <div className="mt-3">
              <span>Stok: </span>
              <span>
                <b>{item?.inventoryQuantity}</b>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
